import { createContext, useContext, useState } from "react";
import { setAdminAuthToken } from "../jscontrol/apiClient";
import StorageManager from "../jscontrol/StorageManager";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const saveAuth = (token, userData) => {
    setAdminAuthToken(token);
    if (userData?.username) StorageManager.username(userData.username);
    setIsAuthenticated(true);
  };

  const logout = () => {
    setAdminAuthToken(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, saveAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
